import { addYears, startOfYear } from 'date-fns';
import Decimal from 'decimal.js';
import { RoundPrices } from "../../models/PriceIncreaseModel";

/**
 * Shared default values for advanced settings.
 * Used by both the popover (quick activation) and the controls (full UI).
 */

// Auto Price Increase Defaults
export const DEFAULT_PRICE_INCREASE_PERCENT = new Decimal(-1);
export const DEFAULT_PRICE_INCREASE_ROUND_PRICES = RoundPrices.None;
export const DEFAULT_PRICE_INCREASE_DATE = now => startOfYear(addYears(now, 1));

// Limit Charges Defaults
export const DEFAULT_LIMIT_BILLING_TIMES = 3;

// Discount Defaults
export const DEFAULT_DISCOUNT_DEADLINE_DAYS = 30;
export const DEFAULT_DISCOUNT_EXPIRATION_YEARS = 1;

// Optional Service Defaults
export const DEFAULT_OPTIONAL_INCLUDED_BY_DEFAULT = false;

// QBO Classes Defaults
export const DEFAULT_QBO_CLASS_ID = '';

// Practice Management Integration Defaults
export const DEFAULT_PRACTICE_MANAGEMENT_TEAM_MEMBERS = {};
export const DEFAULT_PRACTICE_MANAGEMENT_ENABLED = true;
export const DEFAULT_PRACTICE_MANAGEMENT_PRESERVE_EXISTING = false;